import { useMutation, type UseMutationOptions } from '@tanstack/react-query';
import type User from 'register-partners-js/models/user';

interface UseResendEmailMutationOptions {
  user: User;
  onSuccess?: UseMutationOptions['onSuccess'];
}

export function useResendEmailMutation({ user, onSuccess }: UseResendEmailMutationOptions) {
  return useMutation({
    mutationFn: async () => {
      await user.confirmEmail();
    },
    onSuccess,
  });
}
